import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import InboxUI from '../../components/Inbox'
import { useUnreadNotificationsContext } from '../../contexts/UnreadNotifications'

const Inbox = ({ selectedContactId }) => {
  const { markAllAsReadForContact } = useUnreadNotificationsContext()

  useEffect(() => {
    if (selectedContactId) {
      markAllAsReadForContact(selectedContactId)
    }
  }, [selectedContactId, markAllAsReadForContact])

  return <InboxUI />
}

const EnhancedInbox = connect(state => ({
  selectedContactId: state.inbox.conversationSelected,
}))(Inbox)

export default EnhancedInbox
